import '../lib/readmore-fixed';

$(document).ready(function () {
  $('.rw-description__content').readmore({
    embedCSS: true,
    moreLink:
      '<a href="#" data-aos="fade-right" data-aos-delay="200" class="btn btn-secondary mt-4"><i class="icon icon-down icon-down--rotate"></i> Lees meer</a>',
    lessLink:
      '<a href="#" onclick="window.scrollTo(\'.rw-description__content\')" class="btn btn-secondary mt-4"><i class="icon icon-down icon-down--rotate"></i> Lees minder</a>',
    collapsedHeight: 203,
    beforeToggle: function () {
      $('.rw-description__content').toggleClass('active-readmore');
    },
  });

  $('.rw-description__features').readmore({
    embedCSS: true,
    moreLink:
      '<a href="#" data-aos="fade-right" data-aos-delay="200" class="btn btn-secondary mt-4"><i class="icon icon-down icon-down--rotate"></i> Meer kenmerken</a>',
    lessLink:
      '<a href="#" onclick="window.scrollTo(\'.rw-description__features\')" class="btn btn-secondary mt-4"><i class="icon icon-down icon-down--rotate"></i> Minder kenmerken</a>',
    collapsedHeight: 400,
    beforeToggle: function () {
      $('.rw-description__features').toggleClass('active-readmore');
    },
  });
});
